import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgPinFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.212 16.59c0-6.998-5.791-12.672-12.936-12.672-7.144 0-12.936 5.674-12.936 12.673 0 5.756 8.752 20.19 11.858 24.778a1.3 1.3 0 0 0 1.078.567 1.3 1.3 0 0 0 1.078-.567c3.107-4.587 11.858-19.022 11.858-24.778Zm-12.935 3.622c2.041 0 3.696-1.621 3.696-3.62 0-2-1.655-3.622-3.696-3.622-2.042 0-3.697 1.621-3.697 3.621s1.655 3.62 3.697 3.62Z"
            />
        </svg>
    )
}
SvgPinFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgPinFill
